export const TOKEN_FIELD = 'token'
export const CURRENT_LANGUAGE_FIELD = 'current-language'